import { keywordActions } from "../../actionTypes";

const initialState = {
	keywords: {},
	fetching: false,
	fetched: false,
	error: null,
};

const Reducer = (state = initialState, action) => {
	switch (action.type) {
		case keywordActions.FETCH_KEYWORDS: {
			return { ...state, ...initialState };
		}

		case keywordActions.FETCH_KEYWORDS_FULFILLED: {
			return {
				...state,
				fetching: false,
				fetched: true,
				keywords: action.payload.data,
			};
		}

		case keywordActions.FETCH_KEYWORDS_REJECTED: {
			return { ...state, fetching: false, error: action.payload };
		}

		default:
	}

	return state;
};

export default Reducer;
